import React, { useState, useEffect } from 'react';
import { FixedSizeList as List } from 'react-window';
import { useWindowResize } from 'utils/useWindowResize';
import { DropdownItem } from './DropdownItem';

const ITEM_HEIGHT = 36;

const Row = ({ data, index, searchQuery, onChange }) => {
	return (
		<DropdownItem
			{...data[index]}
			searchQuery={searchQuery}
			onChange={onChange}
		/>
	);
};

export const VirtualList = ({ data, wrapperRef, searchQuery, onChange }) => {
	const [height, setHeight] = useState(0);
	const [, windowHeight] = useWindowResize();

	useEffect(
		() => {
			if (wrapperRef && wrapperRef.current) {
				setHeight(wrapperRef.current.clientHeight);
			}
		},
		[wrapperRef, windowHeight]
	);

	return (
		<List
			height={height}
			width="100%"
			itemCount={data.length}
			itemSize={ITEM_HEIGHT}
			itemData={data}
		>
			{({ data, index, style }) => (
				<div style={style}>
					<Row
						data={data}
						index={index}
						searchQuery={searchQuery}
						onChange={onChange}
					/>
				</div>
			)}
		</List>
	);
};
